import Popover from 'bootstrap/js/src/popover';

window.customElements.define('x-hotspot', class extends HTMLElement {
  constructor() {
    super();
    this.setAttribute('tabindex', '0');
    this.content = document.createElement('div');
    this.content.innerHTML = `<button class="hotspot__close"></button><div class="text-center">${this.innerHTML}</div>`;
    this.style.left = this.getAttribute('left');
    this.style.top = this.getAttribute('top');
    this.innerHTML = '<div class="hotspot__marker"></div>';
    this.bsPopover = new Popover(this, {
      content: this.content,
      // trigger: 'focus',
      template: '<div class="hotspot-popover"><div class="hotspot-popover__inner"><div class="popover-body" role="popover"></div></div></div>',
      sanitize: false,
      html: true,
      placement: 'bottom',
      fallbackPlacements: ['bottom'],
    });
    this.addEventListener('inserted.bs.popover', () => {
      const parent = this.closest('.hotspots');
      const elements = parent.querySelectorAll('x-hotspot');
      elements.forEach((e) => {
        e.bsPopover.hide();
      });
      const $close = this.bsPopover.tip.querySelector('.hotspot__close');
      if ($close) {
        $close.addEventListener('click', () => this.bsPopover.hide());
      }
    });
  }
});
